import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { gdBenefits, gdCompanyOffers } from "../gdModulesData";

const BenefitList: React.FC<{ items: string[]; variant?: "default" | "accent" }> = ({
  items,
  variant = "default",
}) => (
  <ul className={`gd-benefits__list gd-benefits__list--${variant}`}>
    {items.map((item, index) => (
      <motion.li
        key={item}
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4, delay: index * 0.04 }}
      >
        <span className="gd-benefits__dot" aria-hidden="true" />
        {item}
      </motion.li>
    ))}
  </ul>
);

const GdBenefitsSection: React.FC = () => {
  return (
    <section className="gd-benefits" aria-labelledby="gd-benefits-title">
      <div className="container">
        <div className="gd-benefits__grid">
          <AnimatedSection className="gd-benefits__col">
            <h2 id="gd-benefits-title" className="gd-benefits__title">
              Benefits of Grocery Delivery App
            </h2>
            <p className="gd-benefits__intro">
              With the rise in the on-demand app economy, Grocery mobile apps became popular while
              serving people&apos;s grocery needs right from their home. Here are some benefits of
              Grocery Delivery App that makes it lovable to both customers as well as vendors or
              grocery stores.
            </p>
            <BenefitList items={gdBenefits} />
          </AnimatedSection>

          <AnimatedSection className="gd-benefits__col gd-benefits__col--dark" delay={0.1}>
            <h2 className="gd-benefits__title gd-benefits__title--light">
              What a Best{" "}
              <span className="gd-benefits__highlight">Grocery App Development Company</span> offers
              you?
            </h2>
            <p className="gd-benefits__intro gd-benefits__intro--light">
              Being a renowned Grocery Delivery App Development Company in India, we very well know
              that building a Grocery Shopping Apps involve several perspectives which demand
              inclusion for the efficient running of the app.
            </p>
            <BenefitList items={gdCompanyOffers} variant="accent" />
            <p className="gd-benefits__footer">
              Simply, contact us today and receive budget friendly online grocery app development
              services from us.
            </p>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default GdBenefitsSection;
